import React from "react";
import { FaRegStar, FaStar } from "react-icons/fa";



const GradeComponent = ({ value, onChange }) => {


  
  const onStarClickHandler = (index) => () => {
    if (value === index) return onChange(0);
    onChange(index)
  }

  const renderStar = (el, ind) => {
    const Component = value > ind ? FaStar : FaRegStar
    return (
      <Component
        color='#7b2b2a'
        onClick={onStarClickHandler(ind + 1)}
        size={24}
        style={{cursor: 'pointer'}}
      />
    )
  }



  return (
    <div>
      {new Array(5).fill(null).map(renderStar)}
    </div>
  )
}

export default GradeComponent